import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Thief: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 420c-40.08 0-77.74-15.49-106.04-43.62-28.35-28.18-43.96-65.76-43.96-105.81 0-82.71 67.29-150 150-150s150 67.29 150 150c0 40.05-15.61 77.63-43.96 105.81-28.29 28.13-65.95 43.62-106.04 43.62zm0-269.43c-66.17 0-120 53.83-120 120 0 32 12.47 62.02 35.12 84.53 22.63 22.5 52.78 34.89 84.88 34.89s62.25-12.39 84.88-34.89c22.65-22.51 35.12-52.53 35.12-84.53 0-66.17-53.83-120-120-120z' />
    <path d='m375 480h30v120h-30z' />
    <circle cx='390' cy='655' r='25' />
    <path d='m630 570h-30c0-18.96-5.27-37.64-15.65-55.53-10.34-17.81-25.21-33.98-44.18-48.06-40.34-29.93-93.67-46.41-150.16-46.41s-109.82 16.48-150.16 46.41c-18.98 14.08-33.84 30.25-44.18 48.06-10.39 17.89-15.65 36.57-15.65 55.53h-30c0-24.32 6.63-48.07 19.71-70.59 12.4-21.36 29.98-40.57 52.26-57.09 45.48-33.74 105.15-52.32 168.04-52.32s122.56 18.58 168.04 52.32c22.27 16.52 39.85 35.73 52.26 57.09 13.08 22.53 19.71 46.28 19.71 70.59z' />
  </IconBase>
));

Thief.displayName = 'Thief';

export default Thief;
